module.exports = new __parcel__URL__("GT_P_1_002.1d82f81e.json").toString();